import _ from 'lodash';
import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

import * as constants from '../../constants';

const Context = React.createContext();

export const MailMergeFieldProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();
    
    const listRecords = useCallback(async (props) => {
        const mailMergeCategoryId = convertMailMergeCategoryToMergeFieldCategory(props);
        const url = "MailMergeField" + (mailMergeCategoryId !== 0 ? `/Category/${mailMergeCategoryId}` : "");
        await execute({ scope: 'list', url: url, method: 'GET', secure: true });
    }, [execute]);

    const convertMailMergeCategoryToMergeFieldCategory = (props) => {
        let mailMergeCategoryId = (!_.isEmpty(props) && _.isNumber(parseInt(props.mailMergeCategoryId))) ? props.mailMergeCategoryId : 0;

        if (mailMergeCategoryId === constants.MAILMERGECATEGORY_PROSPECT) { mailMergeCategoryId = constants.MERGEFIELDCATEGORY_PROSPECT; }
        else if (mailMergeCategoryId === constants.MAILMERGECATEGORY_AGENT) { mailMergeCategoryId = constants.MERGEFIELDCATEGORY_AGENT; }
        else if (mailMergeCategoryId === constants.MAILMERGECATEGORY_VENDOR) { mailMergeCategoryId = constants.MERGEFIELDCATEGORY_VENDOR; }
        else if (mailMergeCategoryId === constants.MAILMERGECATEGORY_CLIENT) { mailMergeCategoryId = constants.MERGEFIELDCATEGORY_CLIENT; }
        else if (mailMergeCategoryId === constants.MAILMERGECATEGORY_LISTING) { mailMergeCategoryId = constants.MERGEFIELDCATEGORY_LISTING; }
        else if (mailMergeCategoryId === constants.MAILMERGECATEGORY_SALE) { mailMergeCategoryId = constants.MERGEFIELDCATEGORY_SALE; }
        else if (mailMergeCategoryId === constants.MAILMERGECATEGORY_OUTSIDEAGENT) { mailMergeCategoryId = constants.MERGEFIELDCATEGORY_OUTSIDEAGENT; }
        else if (mailMergeCategoryId === constants.MAILMERGECATEGORY_RENTAL) { mailMergeCategoryId = constants.MERGEFIELDCATEGORY_RENTAL; }

        return mailMergeCategoryId;
    };

    const value = { listRecords, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useMailMergeFieldStore = () => React.useContext(Context);
